const addOrRemove = (selectedIndexes, column, row) => {
  const value = `${column}x${row}`;
  const found = selectedIndexes.find(item => item === value);
  if (found !== undefined) {
    return selectedIndexes.filter(item => item !== value);
  } else {
    return [...selectedIndexes, value];
  }
};

export default addOrRemove;
